export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-15',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
